import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Collapse, Row } from '@themesberg/react-bootstrap';
import { useCookies } from 'react-cookie';
import { getSummaryReward } from '../../../../controller/api/statistic/reward';
import { Context } from '../Reward';

const formatNumber = value => Number(value || 0).toLocaleString('vi-VN');

export default function Summary() {
  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong']);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const { from, to, phone, gameId, gameScope, paymentStatus, minReward, maxReward } = state.filter;

  useEffect(() => {
    let active = true;
    setLoading(true);
    getSummaryReward(cookies.lottmekong, { from, to, phone, gameId, gameScope, paymentStatus, minReward, maxReward })
      .then(response => {
        if (active && response) dispatch({ type: 'SET_SUMMARY', payload: response });
      })
      .catch(error => console.error('Error fetching reward summary:', error))
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [cookies.lottmekong, from, to, phone, gameId, gameScope, paymentStatus, minReward, maxReward, state.filterPressCount, dispatch]);

  const items = [
    ['Số vé trúng', state.summary.count, ''],
    ['Tổng giải thưởng', state.summary.gross, ''],
    ['Thuế', state.summary.tax, 'text-danger'],
    ['Phí', state.summary.fee, 'text-warning'],
    ['Thực nhận', state.summary.net, 'text-success'],
    ['Chưa trả thưởng', state.summary.unPaided, 'text-danger']
  ];

  return (
    <Card border="light" className="shadow-sm reward-summary">
      <Card.Header className="bg-white p-0">
        <button
          type="button"
          className="w-100 border-0 bg-transparent px-3 py-2 text-start d-flex align-items-center justify-content-between"
          aria-expanded={expanded}
          aria-controls="reward-summary-details"
          onClick={() => setExpanded(value => !value)}
        >
          <span><span className="me-2">💰</span><strong>Thống kê trả thưởng</strong>{loading && <small className="text-muted ms-2">Đang cập nhật...</small>}</span>
          <span className="text-nowrap">{expanded ? 'Thu gọn ▴' : 'Mở rộng ▾'}</span>
        </button>
      </Card.Header>
      <Collapse in={expanded}>
        <div id="reward-summary-details">
          <Card.Body className="p-2">
            <Row className="g-2">
              {items.map(([label, value, className]) => (
                <Col key={label} xs={6} md={4} xl={2}>
                  <div className="reward-summary-item">
                    <small className="text-muted">{label}</small>
                    <strong className={className}>{formatNumber(value)}{label !== 'Số vé trúng' && label !== 'Chưa trả thưởng' ? ' đ' : ''}</strong>
                  </div>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
}
